import Contacts from './contacts'

/**
 * 员工附属人类 - 家人之类的
 * 实质是常旅客，只是多了一个 clkFlag 为 1 的标识
 */
class vipEmpFS extends Contacts {
  constructor(contacts = {}) {
    super(contacts)
    this.clkFlag = 1
  }
}

export default vipEmpFS